<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>
<style>
body{
  background:#eef3f8 !important;
}
.search{
  margin-bottom: 1px;
}
/*场馆列表-首页-通用列表样式*/
.list-box{
  height:146px;
  background: #FFFFFF;
  border-radius:6px;
  margin:8px 0;
}
.list-top{
  display: flex;
  flex-direction: row;
  padding: 8px;
  align-items: flex-start;
  justify-content: space-between;
}
.list-top img{
  width: 124px;
  height: 88px;
}
.list-r{
  display: flex;
  flex: 1;
  margin-left: 8px;
  flex-direction: column;
  /*height: 88px;*/
}
.list-r h2{
  display: flex;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
  margin-bottom: 10px;
  overflow:hidden;
  text-overflow:ellipsis;
  display:-webkit-box;
  -webkit-line-clamp:1;
  -webkit-box-orient:vertical;
  webkit-text-size-adjust: none;
  font-size:14px;
  height: 16px;
  line-height: 16px;
}
.taglist{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.adress{
  display: flex;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height:16px;
  align-items: top;

}
.adress img{
  display: flex;
  width: 10px;
  height: 12px;
  margin-right:3px;
  margin-top: 2px;
}
.y-but{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2C68E4;
}
.y-but{
  border-top: 1px solid #DEDEDE;
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2C68E4;
}

</style>
<style scoped>
/* 搜索样式 */
/deep/.van-search__content{
  background: #F9F8F8;
  border: 1px solid #DEDEDE;
  border-radius: 3px;
  height:32px;
}
/deep/.van-search__action{
  width: 45px;
  height:32px;
  background: #883032;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height:32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 4px;
}
/deep/.van-search .van-cell{
  padding: 0 8px 0 0;
  line-height: 32px;
}
/deep/.van-search--show-action{
  padding-right: 12px;
}
/* tab */
/deep/.van-tabs--line .van-tabs__wrap{
  height:48px;
}
/deep/.van-tab span{
  font-size:14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 18px;
  display: flex;
  align-items: center;
}
/deep/.van-tab--active span{
  font-weight: bold;
  color:#2C68E4;
}
/deep/ .van-tabs__line {
  background-color: #2C68E4;
}
/*场馆列表-首页-通用列表样式*/
/deep/.van-list{
  padding: 0 10px;
  margin-bottom: 10px;

}
/deep/.van-tag--plain{
  height:20px;
  background: #E6EBFF;
  border-radius:100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  margin-right: 5px;
  display: flex;
  font-size: 11px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color:#5D92B4;
}
/deep/.van-hairline--surround::after{
  border: none;
}
/deep/.van-nav-bar{
  background: #2C68E4;
}
/deep/.van-nav-bar .van-icon{
  color: #ffffff;
}
/deep/.van-nav-bar__text{
  color: #ffffff;
}
/deep/.van-nav-bar__title{
  color: #ffffff;
}
/deep/.c-class{margin-top: 1px}
/deep/.b-but{
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding:15px 0;
}
/deep/.b-but .van-button{
  height:45px;
  background: #2C68E4;
  border-radius: 3px;
  width: 90%;
}
/deep/.b-but button{
  height:45px;
  background: #2C68E4;
  border-radius: 3px;
  width: 90%;
  border: none;
  color: #ffffff;
}
/deep/.fiex-box{
  position: fixed;
  bottom: 50px;
  left: 0;
  width: 100%;
  background: #ffffff;
  border-top: 1px solid #f1f1f1;
}
/deep/.newheight{
  height:76px;
}
</style>
